import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class MwTextarea extends Component {

  @tracked selectedOption = 'Posts';
  @tracked selectedOption2 = 'Watch';
  @tracked selectedOption3 = 'Photos';
  @tracked selectedOption4 = 'Schedule';
}
